const moment = require('moment-timezone');
moment.updateLocale('es', {
  months: 'Enero_Febrero_Marzo_Abril_Mayo_Junio_Julio_Agosto_Septiembre_Octubre_Noviembre_Diciembre'.split('_'),
  monthsShort: 'ene_feb_mar_abr_may_jun_jul_ago_sept_oct_nov_dec'.split('_'),
  weekdays: 'domingo_lunes_martes_miercoles_jueves_viernes_sabado'.split('_'),
  weekdaysShort: 'dom_lun_mar_mier_jue_vier_sab'.split('_'),
  weekdaysMin: 'do_lu_ma_mi_ju_vi_sa'.split('_')
});
